import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  FormLayout,
  TextField,
  InlineError,
  Select,
  Toast,
  PageActions,
  Loading,
  Text,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import Select2 from "react-select";

const PurchaseOnDemandVideo = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(true);
  const [optionsUsers, setOptionsUsers] = useState([]);
  const [user, setUser] = useState("");
  const [userError, setUserError] = useState("");
  const [method, setMethod] = useState("");
  const [methodError, setMethodError] = useState("");
  const [bankTransferAmount, setBankTransferAmount] = useState("");
  const [bankTransferAmountError, setBankTransferAmountError] = useState("");
  const [error, setError] = useState("");

  const handleChangeUser = (newValue) => {
    setUser(newValue);
    setUserError("");
  };
  const handleChangeMethod = (newValue) => {
    setMethod(newValue);
    setMethodError("");
    if (newValue !== "bank_transfer") {
      setBankTransferAmount("");
      setBankTransferAmountError("");
    }
  };
  const handleChangeBankTransferAmount = (newValue) => {
    setBankTransferAmount(newValue);
    setBankTransferAmountError("");
  };

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Video has been purchased successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    try {
      const responseUsers = await axios.get(`/app/users?get_all=1`);
      setOptionsUsers(
        responseUsers.data.data.map((item) => ({
          label:
            item.id +
            " " +
            item.first_name +
            " " +
            item.last_name +
            ` (Email: ${item.email})`,
          value: String(item.id),
        }))
      );
    } catch (err) {
      console.log(err);
    }
    setIsSaving(false);
  }

  function handleSave() {
    if (user === "" || method === "") {
      user === "" && setUserError("Please choose a user");
      method === "" && setMethodError("Please choose a payment method");
      return;
    }
    if (method === "bank_transfer" && bankTransferAmount === "") {
      setBankTransferAmountError("Please enter an amount");
      return;
    }

    setError("");
    setIsSaving(true);
    axios
      .post(`/on-demand-videos/${id}/purchase`, {
        user_id: user.value,
        payment_method: method,
        ...(method === "bank_transfer" &&
          bankTransferAmount && {
            bank_transfer_amount: bankTransferAmount,
          }),
      })
      .then(() => {
        setIsSaving(false);
        navigate(`/admin/on-demand-videos/${id}/subscribers`);
      })
      .catch((err) => {
        setError(err?.response?.data?.message || "An error occurred");
        setIsSaving(false);
      });
  }

  return (
    <Page
      narrowWidth
      backAction={{
        onAction: () => navigate(`/admin/on-demand-videos/${id}/subscribers`),
      }}
      title="Book"
    >
      {isSaving ? <Loading /> : null}
      <Card>
        <FormLayout>
          <Text>User</Text>
          <Select2
            options={optionsUsers}
            onChange={handleChangeUser}
            value={user}
            placeholder="Please select"
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
            }}
          />
          <InlineError message={userError} />

          <Select
            label="Payment Method"
            options={[
              { label: "Wallet", value: "wallet" },
              { label: "Offline Card", value: "offline_card" },
              { label: "Cash", value: "cash" },
              { label: "Bank Transfer", value: "bank_transfer" },
            ]}
            onChange={handleChangeMethod}
            value={method}
            error={methodError}
            placeholder="Please select"
          />
          {method === "bank_transfer" && (
            <TextField
              label="Amount"
              type="number"
              value={bankTransferAmount}
              onChange={handleChangeBankTransferAmount}
              error={bankTransferAmountError}
              placeholder="Enter amount"
            />
          )}

          <InlineError message={error} />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
      />
      {toastMarkup}
    </Page>
  );
};

export default PurchaseOnDemandVideo;
